import React from "react";

interface SwipeCardLoadMoreProps {
  isLoading: boolean;
  onClick?: () => void;
  skeletonType?: "tour" | "post";
}

const SwipeCardLoadMore: React.FC<SwipeCardLoadMoreProps> = ({
  isLoading,
  onClick,
  skeletonType = "tour",
}) => {
  const skeletons = {
    tour: (
      <div className="w-full animate-pulse flex flex-col h-full">
        {/* image block */}
        <div className="w-full h-48 bg-gray-200 rounded-t-md"></div>
        <div className="p-4 flex flex-1 flex-col justify-between">
          {/* title */}
          <div className="h-4 bg-gray-200 rounded w-4/5 mt-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
          {/* tags */}
          <div className="flex items-center mb-2">
            <div className="h-4 bg-gray-200 rounded px-8 py-1 mr-2"></div>
            <div className="h-4 bg-gray-200 rounded px-5 py-1"></div>
          </div>
          {/* description */}
          <div className="h-3 bg-gray-200 rounded w-full"></div>
          <div className="h-3 bg-gray-200 rounded w-full"></div>
          <div className="h-3 bg-gray-200 rounded w-5/6 mb-6"></div>
          {/* price */}
          <div className="h-4 bg-gray-200 rounded w-2/5 mb-8"></div>
        </div>
      </div>
    ),
    post: (
      <div className="w-full animate-pulse flex flex-col h-full">
        {/* image block */}
        <div className="w-full h-48 bg-gray-200 rounded-t-md"></div>
        <div className="p-4 flex flex-1 flex-col justify-between">
          {/* title */}
          <div className="h-4 bg-gray-200 rounded w-4/5 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3 mb-6"></div>
          {/* tags */}
          <div className="flex items-center mb-2">
            <div className="h-4 bg-gray-200 rounded px-8 py-1 mr-2 mb-4"></div>
          </div>
          {/* description */}
          <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-5/6 mb-8"></div>
        </div>
      </div>
    ),
  };
  return (
    <div
      className="flex w-full mb-4 items-center justify-center bg-white border border-gray-200 rounded-lg cursor-pointer shadow-lg"
      onClick={!isLoading ? onClick : undefined}
    >
      {isLoading ? (
        skeletons[skeletonType]
      ) : (
        <div className="p-4 text-center text-gray-800 font-medium">
          Load More
        </div>
      )}
    </div>
  );
};

export default SwipeCardLoadMore;
